<div class="wrap-graphcard card-bg-white">
  <!-- <p class="gc-title">{{creative.title}}</p> -->
  <app-inner-html [text]="creative.title"></app-inner-html>
  <div class="wrap-graph-card">
    <!-- <p>{{ creative.content }}</p> -->
    <app-inner-html [text]="creative.content"></app-inner-html>
    <div class="img-wrap">
      <img class="card-img" [ngClass]="{'wide': isWideImage, 'tall': !isWideImage}" [src]="creative.media.length > 0 ? creative.media[0].url : 'assets/images/graph.png'"
        alt="Feed Image" />
    </div>
  </div>
</div>
